module.exports = __webpack_public_path__ + "img/Img1.7ab50c1a.png";